import { BaseService } from './BaseService';

/**
 * Client Type Service Class
 * Handles all client type related API operations
 */
class ClientTypeService extends BaseService {
    constructor() {
        super('/api/clientTypes');
    }

    /**
     * Validate client type data
     * @param {Object} data - Client type data
     */
    validateClientTypeData(data) {
        // Add any client type specific validation here
        if (data.name && typeof data.name !== 'string') {
            throw new Error('Client type name must be a string');
        }
    }

    /**
     * Create a new client type with validation
     * @param {string} accessToken - JWT access token
     * @param {Object} data - Client type data
     * @returns {Promise<Object>} Created client type object
     */
    async create(accessToken, data) {
        this.validateClientTypeData(data);
        return super.create(accessToken, data);
    }

    /**
     * Update an existing client type with validation
     * @param {string} accessToken - JWT access token
     * @param {number} id - Client type ID
     * @param {Object} data - Updated client type data
     * @returns {Promise<Object>} Updated client type object
     */
    async update(accessToken, id, data) {
        this.validateClientTypeData(data);
        return super.update(accessToken, id, data);
    }
}

// Export singleton instance
export const clientTypeService = new ClientTypeService();

// Export individual methods for convenience
export const {
    getAll: getAllClientTypes,
    getById: getClientTypeById,
    create: createClientType,
    update: updateClientType,
    delete: deleteClientType,
    search: searchClientTypes
} = clientTypeService;

export default clientTypeService;
